import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITeamMember } from "../teamMemberModel";

export const getAllTeamMember = createAsyncThunk(
  "TeamMember/FindAllTeamMember",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/FindAllTeamMember`,
        {
          CustomerName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Team Member:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTeamMember = createAsyncThunk(
  "TeamMember/InsertTeamMember",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/InsertTeamMember`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Team Member:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTeamMember = createAsyncThunk(
  "TeamMember/UpdateTeamMember",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/UpdateTeamMember`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Team Member:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTeamMember = createAsyncThunk(
  "TeamMember/DeleteTeamMember",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/DeleteTeamMember`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Team Member :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTeamMemberByID = createAsyncThunk(
  "TeamMember/FindByIDTeamMember",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/FindByIDTeamMember`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SequenceNo: result.SequenceNo,
        Name: result.Name,
        Designation: result.Designation,
        xlink: result.xlink,
        Linkedin: result.Linkedin,
        Facebook: result.Facebook,
        InstaLink: result.InstaLink,
        Image: result.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as ITeamMember;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Team Member :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTeamMember = createAsyncThunk(
  "TeamMember/FindAllActiveTeamMember",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/TeamMember/FindAllActiveTeamMember`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Team Member:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTeamMember = createAsyncThunk(
  "TeamMember/ActiveInActiveMember",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/ActiveInActiveMember`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Team Member :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const TeamMemberImageUpload = createAsyncThunk(
  "TeamMember/TeamMemberImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/TeamMemberImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Team Member Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
